import styled, { css } from 'styled-components';
import { darkMode, darkPalette } from '../../core/theme/darkTheme';

export const LogoWrapper = styled.div<{ $isBig: boolean }>`
  position: relative;
  rotate: -11.7deg;
  ${({ $isBig }) => $isBig && `zoom: 2.38;`};
`;

export const Logo = styled.div`
  width: 42px;
  height: 42px;
  background: url(${'/images/header-logo.svg'}) center / contain no-repeat;
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 96%;
    height: 96%;
    position: absolute;
    top: 3px;
    left: 3px;
    background-color: #c7e2ff;
    border-radius: 12px;
    rotate: 19.2deg;
    z-index: -1;
  }

  ${darkMode(css`
    &::before {
      background-color: ${darkPalette.accentMuted};
    }
  `)}
`;
